var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.389,
    height: 32.37,
    viewBox: "0 0 32.389 32.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "announcement",
    d: "M14.286,7.065V25.908a2.482,2.482,0,0,1-4.823.835L6.436,18.068m17.723-.962a4.232,4.232,0,1,0,0-8.463M6.436,18.07A5.643,5.643,0,0,1,8.642,7.233h2.585c5.784,0,10.756-1.741,12.932-4.232V22.748c-2.176-2.491-7.148-4.232-12.932-4.232H8.642a5.62,5.62,0,0,1-2.206-.447Z",
    transform: "translate(-3.01 5.067) rotate(-15.009)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.4373d06f62ed7ddf364f2e9fc00573d1.svg";
export { ForwardRef as ReactComponent };